<template>
<van-config-provider :theme-vars="themeVars" style="height:100%">
  <van-nav-bar :title="$route.meta.title"  left-arrow v-if="['index','login'].indexOf($route.name)==-1"  @click-left="onClickLeft" />
  <router-view />
</van-config-provider>
</template>
<script>
import { provide } from "vue";
import { useRoute, useRouter } from "vue-router";
export default {
  name: "App",
  setup() {
    // 路由
    provide("$router", useRouter());
    provide("$route", useRoute());
    const router=useRouter()
    const onClickLeft = () => {
      router.back(-1);
    };
    //  window.addEventListener('hashchange', () => {undefined

    //   let currentPath = window.location.hash.slice(1)

    //   if (route.path !== currentPath) {undefined

    //     router.push(currentPath)

    //   }

    // }, false)
    const themeVars={
     
    }
    return {
      onClickLeft,
      themeVars
    };
  },
};
</script>
<style lang="scss">
@import "./styles/base.scss";
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-color: #f5f5f5;
  -webkit-overflow-scrolling: touch;
}
</style>
<style>

</style>